module.exports = require('react/lib/update');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-toastr/~/react-addons-update/index.js
 ** module id = 16
 ** module chunks = 0
 **/